export default __webpack_public_path__ + "static/media/jornal_compas.ad4df30c.png";